import { generateTypes } from 'reducers/utils/HttpReducerHelper';

export const updateFundingEnquiryStatus = generateTypes('FUNDING_ENQUIRY', 'UPDATE_STATUS');
